module.exports = __webpack_public_path__ + "static/datamanagementportal_b-c90568fbdc9525debe32b450ba77d90f.jpg";